import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    sneakerLegacy: {
      ref: null,
      carouselSlide: null,
    },
  },
  getters: {
    getSneakerLegacyRef: (state) => state.sneakerLegacy.ref,
    getSneakerLegacySlide: (state) => state.sneakerLegacy.carouselSlide,
  },
  mutations: {
    setSneakerLegacyRef(state, payload) {
      state.sneakerLegacy.ref = payload;
    },
    setSneakerLegacySlide(state, payload) {
      state.sneakerLegacy.carouselSlide = payload;
    },
  },
  actions: {},
});
